import React, { createContext, useContext } from 'react';
import useFirebaseAnalytics from '../hooks/useFirebaseAnalytics';
import { EventParams } from '../components/Analytics/AnalyticsTypes';

interface AnalyticsContextType {
  trackEvent: (eventName: string, eventParams?: EventParams) => void;
}

const AnalyticsContext = createContext<AnalyticsContextType>(undefined);

export const AnalyticsProvider = ({
  children,
  contextParams = {},
}: {
  children: React.ReactNode;
  contextParams?: EventParams;
}) => {
  const analytics = useFirebaseAnalytics();

  const trackEvent = (eventName: string, eventParams: EventParams = {}) => {
    const mergedParams: EventParams = {
      ...contextParams,
      ...eventParams,
    };

    analytics.logEvent(eventName, mergedParams);
  };

  return <AnalyticsContext.Provider value={{ trackEvent }}>{children}</AnalyticsContext.Provider>;
};

export const useContextAnalytics = () => {
  return useContext(AnalyticsContext);
};
